<template>
    <div class="card">
        <div class="card-header">
            <h1>{{ $trans.get('__JSON__.Recalculating bonuses') }}</h1>
        </div>
        <div class="card-body">
            <div v-if="calculation" class="row">
                <div class="col-1">{{ $trans.get('__JSON__.Range') }}:</div>
                <div class="col-2">{{ calculation }}</div>
            </div>
            <div v-if="calculation" class="row">
                <div class="col-1">{{ $trans.get('__JSON__.Day') }}:</div>
                <div class="col-2">{{ day }}</div>
            </div>
            <button v-if="firstanswer && calculation == null" class="btn btn-primary"
                @click.stop="reload">Refresh</button>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalculationStatus",

    data() {
        return {
            calculation: null,
            day: null,
            firstanswer: false
        }
    },

    mounted() {
        setInterval(this.refreshStatus, 1000);
    },
    methods: {
        refreshStatus() {
            axios
                .get("/api/calculationstatus")
                .then((resp) => {
                    console.log(resp.data);
                    this.calculation = resp.data.calculation;
                    this.day = resp.data.day;
                    this.firstanswer = true;
                })
                .catch((error) => {
                    console.log(error.response.data.errors);
                    this.errors = error.response.data.errors;
                });
        },
        reload() {
            location.reload();
        },
    }


}
</script>

<style></style>